module.exports = __webpack_public_path__ + "media/en_gb_s1_Alice.8f5c2e42.mp3";